import { useEffect, useState } from "react";
import NavBar from "../../../components/NavBar";
import {
  Str_Confirm,
  Str_GroupAnnouncement,
  Str_OnlyGroupAdminCanEdit,
} from "../../../language/string_res";
import BaseScreen from "../../BaseScreen";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { postJson } from "../../../net/http";
import { useChatStore } from "../../../store/ChatStore";
import {
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import {
  ColorLine,
  color_333333,
  color_999999,
  color_BEBEBE,
  color_main,
  white,
} from "../../../assets/style/colors";
import { hideLoading, showLoading } from "../../../components/Loading";
import { useIsFocused } from "@react-navigation/native";
import * as ImSdk from "../../../../imsdk/api";
import { ScrollView } from "react-native-gesture-handler";
import { ScreenCloseModal } from "../../../components/ScreenModal";
import { BottomButtonView } from "../../../components/BottomButtonView";
export const GroupNotice = ({
  navigation,
  route,
}: MainNavProps<"GroupNotice">) => {
  const tid = route.params.tid;
  const [canEdit, setCanEdit] = useState(route.params.canEdit);
  const [notice, setNotice] = useState(route.params.notice);
  const { chatState, chatDispatch } = useChatStore();
  const { group } = chatState.curTopicWithSummary;
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused && group) {
      group.notice_read = "0";
      ImSdk.getInstance().GroupUpsert(group).then();
      chatDispatch({ type: "UPDATE_NOTICE_READ", payload: "0" });
    }
  }, [isFocused]);

  useEffect(() => {
    if (chatState.isAdmin) {
      setCanEdit(chatState.isAdmin);
    }
  }, [chatState]);
  // 设置群公告
  const handleGroupNotice = () => {
    // if (!notice || notice.length == 0) {
    //     showToast(Str_AnnouncementNotEmpty)
    //     return
    // }
    showLoading();
    const body = { notice: notice, tid: tid };
    postJson(`/v1/sdk/group/profile/set`, { body })
      .then((res: any) => {
        if (res.code === 0) {
          navigation.goBack();
        }
      })
      .finally(() => {
        hideLoading();
      });
  };
  return (
    <ScreenCloseModal title={Str_GroupAnnouncement}>
      {canEdit ? (
        <KeyboardAvoidingView
          behavior={"padding"}
          style={{ overflow: "visible", flex: 1 }}
        >
          <TextInput
            editable={canEdit}
            selectionColor={color_main}
            placeholderTextColor={color_BEBEBE}
            style={style.text}
            textAlign={"left"}
            value={notice}
            autoFocus={canEdit}
            maxLength={200}
            multiline={true} //自动换行
            textAlignVertical={"top"}
            onChangeText={setNotice}
          />
        </KeyboardAvoidingView>
      ) : (
        <ScrollView style={{ flex: 1 }}>
          <Text style={style.text}>{notice}</Text>
        </ScrollView>
      )}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: white,
          paddingVertical: 40,
        }}
      >
        <View style={{ backgroundColor: ColorLine, height: 0.5, width: 80 }} />
        <Text
          style={{ color: color_999999, fontSize: 14, marginHorizontal: 10 }}
        >
          {Str_OnlyGroupAdminCanEdit}
        </Text>
        <View style={{ backgroundColor: ColorLine, height: 0.5, width: 80 }} />
      </View>
      {canEdit && notice !== route.params.notice && (
        <BottomButtonView text={Str_Confirm} onClick={handleGroupNotice} />
      )}
    </ScreenCloseModal>
  );
};

const style = StyleSheet.create({
  text: {
    padding: 16,
    fontSize: 20,
    marginTop: 1,
    color: color_333333,
    backgroundColor: white,
    flex: 1,
  },
});
